import React from 'react';
import PropTypes from 'prop-types';
import { Link, Typography, Box } from '@mui/material';
import { useStyles } from './styles';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import { useRouter } from 'next/router';
import { setLocale } from 'utils/locale';

import en from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';
import ja from './locales/jp';
import ko from './locales/ko';
import zh from './locales/en';

const Props = {
  localeProp: PropTypes.string,
};

const DefaultProps = {
  localeProp: '',
};

export default function PageFooterMobile({ localeProp }) {
  const classes = useStyles();
  const router = useRouter();
  const { locale } = router;
  const isIllustrationsPage = router.asPath.includes('/illustrations');
  const supportedLocales = { en, es, fr, it, ja, ko, zh };
  const currentLocale = localeProp && supportedLocales[localeProp] ? localeProp : locale;
  const t = isIllustrationsPage
    ? setLocale(locale, supportedLocales)
    : setLocale(currentLocale, supportedLocales);

  return (
    <LazyLoad offset={100}>
      <Box>
        <footer className={classes.root}>
          <Link href="https://cactusglobal.com/" target="_blank" underline="hover">
            <Image
              src="/images/cactus-logo-white.svg"
              width={186}
              height={36}
              alt="Cactus Communications Logo"
              loading="lazy"
            />
          </Link>

          <Typography className={classes.copyrightText}>
            {t.copyright} {new Date().getFullYear()} {t.mtgAllRightsReserved}.
          </Typography>

          <Box alignItems="center" className={classes.link}>
            <Link href="/blog/faq/privacy-policy" target="_blank" underline="hover">
              {t.privacyPolicy}
            </Link>

            <span className={classes.verticalDivider}>|</span>

            <Link href="/blog/faq/cookies-policy" target="_blank" underline="hover">
              {t.cookiesPolicy}
            </Link>

            <span className={classes.verticalDivider}>|</span>

            <Link href="/blog/faq/terms-of-use" target="_blank" underline="hover">
              {t.termsOfUse}
            </Link>

            <span className={classes.verticalDivider}>|</span>

            <Link href="https://cactusglobal.com/careers/" target="_blank" underline="hover">
              {t.careers}
            </Link>
          </Box>
        </footer>
      </Box>
    </LazyLoad>
  );
}

PageFooterMobile.propTypes = Props;
PageFooterMobile.defaultProps = DefaultProps;
